module.exports = __webpack_public_path__ + "img/arrow.de5979bb.svg";